import React, { Component } from 'react';
import DynamicComponent from './DynamicComponent';
import OperationLayerType from './OperationLayerType';
import SidebarComponent from './SidebarComponent';

class LayerControlSettingsMainComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDynamicComponentVisible: true,
            selectedDynamicComponent: <OperationLayerType />
        };
    }

    openDynamicComponent = () => {
        this.setState({ isDynamicComponentVisible: true });
    };

    closeDynamicComponent = () => {
        this.setState({ isDynamicComponentVisible: false });
    };

    setSelectDynamicComponent = (setComponent) => {
        this.setState({ selectedDynamicComponent: setComponent })
    }



    render() {
        return (
            <div>
                <div style={{ width: '20%', overflow: 'hidden' }} >
                    <SidebarComponent setSelectedComponent={this.setSelectDynamicComponent} onButtonClick={this.openDynamicComponent} />
                </div>


                <DynamicComponent selectedComponent={this.state.selectedDynamicComponent} onClose={this.closeDynamicComponent} />
            </div>
        )
    }

}

export default LayerControlSettingsMainComponent;